import {ViewStream} from 'spyne';
import ArchSlideTmpl from "./templates/arch-as-data-slide.tmpl.html"
export class PageArchAsDataSlide extends ViewStream {

    constructor(props={}) {
        props.tagName = 'section';
        props.class = "arch-data-slide";
        props.template = ArchSlideTmpl;
        super(props);
    }

    addActionListeners() {
        // return nexted array(s)
        return [];
    }

    broadcastEvents() {
        // return nexted array(s)
        return [];
    }

    onRendered() {

    }

}

